"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _has = _interopRequireDefault(require("lodash/has"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _ReduxForm = require("../../utils/ReduxForm.Functions");
var _BrixelInputText = _interopRequireDefault(require("./BrixelInputText"));
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var FormatData = _interopRequireWildcard(require("../../utils/normalizeFormat"));
var _FormActions = require("../../actions/FormActions");
var _BrixelAvatar = _interopRequireDefault(require("../BrixelAvatar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ReduxField = props => {
  // PROPS
  const {
    allowOtherAnswerInput = true,
    disableEmailRegister = false,
    ReduxFieldClass = '',
    autocomplete = null,
    baseByData,
    baseURL = null,
    changeCountry = () => '',
    changeFieldValue,
    component,
    currentInitialValue = '',
    currentValue = '',
    design = {},
    errors,
    forceToShowError = false,
    form,
    formValue,
    getAllFormData = {},
    handleChangeSyncError,
    hintMessage = '',
    input,
    inputFormat = {},
    labels = {},
    lang,
    mapFunctions = {},
    mapOptions = {},
    meta = {},
    multiple = false,
    pageType,
    onCloseGoBack = () => '',
    onSubmit = () => '',
    onSaveData,
    showCheckMark = false
  } = props;
  // STATE
  // const history = typeof window !== 'undefined' ? window.location.href : '';
  const [validField, setValidField] = (0, _react.useState)(true);
  const [loadingEmail, setLoadingEmail] = (0, _react.useState)(false);
  const [stateValue, setStateValue] = (0, _react.useState)(input.value);
  const [invalidString] = (0, _react.useState)(false);
  const [showValidation, setShowValidation] = (0, _react.useState)(false);
  const nameAutocomplete = (0, _get.default)(input, 'name', '').split('-')[1];
  const currency = (0, _get.default)(inputFormat, 'currency', (0, _get.default)(formValue, 'price.currency', 'CHF'));
  (0, _react.useEffect)(() => {
    return () => handleChangeSyncError(form, input.name, true);
  }, []);
  (0, _react.useEffect)(() => {
    setStateValue(input.value);
  }, [input.value]);
  (0, _react.useEffect)(() => {
    setStateValue(null);
  }, [input.name]);
  const format = value => {
    const formatType = (0, _get.default)(inputFormat, 'formatType', '');
    if (formatType && formatType.split('-')[0] === 'date' && typeof value === 'string') {
      return FormatData.normalizeData(value, formatType.split('-')[1], '');
    }
    if (formatType.split('-')[0] === 'rooms' && typeof value === 'number') {
      return FormatData.formatRooms(value);
    }
    if (formatType.split('-')[0] === 'zipCode' && typeof value === 'string') {
      return FormatData.normalizeZipCode(value, formatType.split('-')[1]);
    }
    if (value || (0, _isNumber.default)(value)) return value;
    return '';
  };
  const normalize = value => {
    const formatType = (0, _get.default)(inputFormat, 'formatType', '');
    if (formatType && formatType.split('-')[0] === 'date' && typeof value === 'string') {
      const newPrevValue = (0, _get.default)(formValue, input.name, '');
      return FormatData.normalizeData(value, formatType.split('-')[1], newPrevValue);
    }
    if (formatType && formatType.split('-')[0] === 'rooms' && (typeof value === 'string' || typeof value === 'number')) {
      return FormatData.normalizeRooms(value);
    }
    if (formatType && typeof formatType === 'string' && formatType.split('-')[0] === 'zipCode' && (typeof value === 'string' || typeof value === 'number')) {
      setTimeout(() => FormatData.normalizeZipCode(value, formatType.split('-')[1]), 1);
    }
    return value;
  };
  const inputMode = () => {
    const formatType = (0, _get.default)(inputFormat, 'formatType', null);
    if (formatType === 'price' || input.type === 'number' || (0, _get.default)(inputFormat, 'formatType', null) === 'price') {
      return 'decimal';
    }
    return null;
  };
  (0, _react.useEffect)(() => {
    if (input.name.includes('email')) setLoadingEmail(false);
  }, [(0, _get.default)(errors, input.name, null)]);
  const checkValidation = () => {
    const validateFiled = input.validate;
    if (validateFiled && validateFiled.length > 0) {
      const validateArray = (0, _get.default)(input, 'validate', []);
      let isValid = true;
      validateArray.forEach(validateFunc => {
        if ((isValid === true || isValid === null) && validateFunc instanceof Function) {
          const value = (0, _get.default)(formValue, input.name, '');
          isValid = validateFunc(value);
        }
      });
      handleChangeSyncError(form, input.name, isValid);
    }
  };
  (0, _react.useEffect)(() => {
    if (input.validate) checkValidation();
  }, [(0, _get.default)(formValue, input.name, null)]);
  (0, _react.useEffect)(() => {
    if (!multiple) {
      if ((0, _get.default)(errors, input.name, null) !== true) {
        setValidField(false);
      } else {
        setValidField(true);
      }
    } else if ((0, _get.default)(errors, input.name, null) !== true && (0, _get.default)(errors, input.name, null) !== null) setValidField(false);else setValidField(true);
    if (input.name.includes('email')) {
      if ((0, _get.default)(errors, input.name, null) !== true && (0, _get.default)(errors, input.name, null) !== null) setValidField(false);else setValidField(true);
    }
  }, [(0, _get.default)(errors, input.name, null)]);
  (0, _react.useEffect)(() => {
    setShowValidation((0, _get.default)(meta, 'showErrors', false));
  }, [(0, _get.default)(meta, 'showErrors', null)]);
  (0, _react.useEffect)(() => {
    checkValidation();
  }, [input.name]);
  const onBlurFunction = async (e, err) => {
    if (input.type) {
      if (e) e.preventDefault();
      if (currentInitialValue !== currentValue && input.type) {
        const formData = (0, _cloneDeep.default)(getAllFormData);
        if (input.validateEmail && !(0, _isEmpty.default)((0, _get.default)(formData, `${form}.values.${input.name}`, null)) && baseURL) {
          checkValidation();
        } else if ((0, _get.default)(err, input.name, null) !== true) {
          setShowValidation(true);
        } else {
          setShowValidation(false);
        }
      } else if ((0, _get.default)(err, input.name, null) !== true) {
        setShowValidation(true);
      } else {
        setShowValidation(false);
      }
    }
    if (input.onBlur) input.onBlur();
  };
  const onFocus = e => {
    if (input.onFocus) input.onFocus(e);
  };
  const onChangeValue = (val, name) => {
    const formData = (0, _cloneDeep.default)(getAllFormData);
    const getCurrentVal = (0, _get.default)(formData, `${form}.values.${input.name}`, null);
    if (getCurrentVal !== val && name !== 'location') {
      if (!(0, _get.default)(meta, 'showErrors', null)) setShowValidation(false);
      if ((0, _get.default)(inputFormat, 'formatType', null) === 'tel') changeFieldValue(form, name, val);else {
        let formatVal = normalize(val);
        if (val === '0') formatVal = val === '0' ? +val : normalize(val);
        if (val === 'false' || val === false) formatVal = false;
        if (val === 'true' || val === true) formatVal = true;
        changeFieldValue(form, name, formatVal);
      }
      if (name.includes('register')) {
        checkValidation();
      }
    }
    if (input.onChange) {
      input.onChange(val);
    }
  };
  const onClickAutocomplete = data => {
    if ((0, _has.default)(autocomplete, `${nameAutocomplete}.func`)) {
      autocomplete[nameAutocomplete].func(data);
    }
  };
  const extractValue = () => (0, _get.default)(formValue, input.name, null) === null ? '' : (0, _get.default)(formValue, input.name, null);
  const isDone = () => {
    if ((0, _get.default)(formValue, input.name, null) && ((0, _get.default)(errors, input.name, null) === null || (0, _get.default)(errors, input.name, null) === true)) {
      return 'doneSection';
    }
    return 'todoSection';
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: `${ReduxFieldClass} ${showCheckMark ? 'showCheckMark' : ''} reduxFieldWrap ${isDone()}`
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(component, {
    ...mapFunctions,
    ...mapOptions,
    // @ts-ignore
    acceptedFile: (0, _get.default)(input, 'acceptedFile', []) || [],
    autofocus: (0, _get.default)(input, 'autofocus', false),
    baseByData: baseByData,
    disableEmailRegister: disableEmailRegister,
    onSaveData: onSaveData ? () => onSaveData() : undefined,
    baseURL,
    blockScroll: input.blockScroll,
    bodyScrollclass: (0, _get.default)(design, 'bodyScrollclass', null),
    borderColor: (0, _get.default)(design, 'borderColor', null),
    bulletPoints: (0, _get.default)(input, 'bulletPoints', null),
    country: input.country,
    changeCountry: val => changeCountry(val),
    changeFieldValue: val => changeFieldValue(form, input.name, val),
    className: (0, _get.default)(design, 'className', ''),
    classNameParent: (0, _get.default)(design, 'classNameParent', ''),
    compact: (0, _get.default)(design, 'compact', ''),
    color: (0, _get.default)(design, 'color', ''),
    deactivable: input.deactivable,
    disableAutocomplete: input.disableAutocomplete,
    disableDelay: (0, _get.default)(input, 'name', '').includes('autocomplete') ? false : (0, _get.default)(input, 'disableDelay', true),
    disabled: input.disabled,
    buttonLabel: (0, _get.default)(labels, 'buttonLabel', null),
    currentInitialValue: currentInitialValue || '',
    extraFeatureCustomList: input.extraFeatureCustomList,
    fluid: (0, _get.default)(design, 'fluid', ''),
    formName: form,
    formatText: (0, _get.default)(design, 'formatText', ''),
    formatType: (0, _get.default)(inputFormat, 'formatType', null),
    formatValue: val => format(val),
    generateValue: input.generateValue,
    showIconValidation: (0, _get.default)(design, 'showIconValidation', ''),
    icons: (0, _get.default)(labels, 'icons', ''),
    skipPhone: input.skipPhone,
    onSelectAddress: input.onSelectAddress,
    deleteMultiCity: index => input.deleteMultiCity ? input.deleteMultiCity(index) : undefined,
    multiCities: input.multiCities,
    currency,
    input: {
      addPlusOnLast: input.addPlusOnLast || false,
      invertScale: input.invertScale || false,
      name: input.name,
      onBlur: e => onBlurFunction(e, errors),
      onChange: (val, name) => onChangeValue(val, name || input.name),
      onFocus: e => onFocus(e),
      onRemove: e => input.onRemove ? input.onRemove(e) : '',
      value: extractValue()
    },
    inputClassName: (0, _get.default)(design, 'inputClassName', ''),
    inputMode: inputMode(),
    isHorizontal: (0, _get.default)(design, 'isHorizontal', ''),
    cardLayout: (0, _get.default)(design, 'cardLayout', ''),
    svgWidth: (0, _get.default)(design, 'svgWidth', ''),
    stretched: (0, _get.default)(design, 'stretched', ''),
    svgSupport: (0, _get.default)(design, 'svgSupport', ''),
    cardSmall: (0, _get.default)(design, 'cardSmall', ''),
    large: (0, _get.default)(design, 'large', ''),
    pdClass: (0, _get.default)(design, 'pdClass', ''),
    wrapClass: (0, _get.default)(design, 'wrapClass', ''),
    iconClass: (0, _get.default)(design, 'iconClass', ''),
    isLoading: loadingEmail || input.isLoading,
    labelButton: (0, _get.default)(labels, 'labelButton', undefined),
    label: (0, _get.default)(labels, 'label', ''),
    labelHtml: (0, _get.default)(labels, 'labelHtml', ''),
    labelLeft: (0, _get.default)(labels, 'labelLeft', ''),
    labelType: (0, _get.default)(labels, 'labelType', ''),
    lang,
    minDate: input.minDate,
    maxDate: input.maxDate,
    max: (0, _get.default)(inputFormat, 'max', null),
    maxLengthNum: (0, _get.default)(inputFormat, 'maxLengthNum', undefined),
    modal: input.modal,
    meta: {
      invalid: multiple ? (0, _get.default)(errors, input.name, true) !== true && showValidation : forceToShowError || !validField && showValidation,
      dirty: ((0, _get.default)(formValue, input.name, null) !== null || (0, _get.default)(meta, 'showErrors', false)) && (0, _get.default)(errors, input.name, true) !== true || forceToShowError
    },
    message: {
      error: (0, _get.default)(meta, 'message.error', null) ? (0, _get.default)(meta, 'message.error', null) : (0, _get.default)(errors, input.name, invalidString)
    },
    noTranslate: (0, _get.default)(input, 'noTranslate', false),
    showFullSelectDate: input.showFullSelectDate,
    // onDisableValidation: (val) => functions.onDisableValidation ? functions.onDisableValidation(val) : '',
    min: (0, _get.default)(inputFormat, 'min', undefined),
    minLengthNum: (0, _get.default)(inputFormat, 'minLengthNum', undefined),
    moreInfo: (0, _get.default)(input, 'moreInfo', null),
    normalizeValue: val => normalize(val),
    onCloseGoBack: e => onCloseGoBack(e),
    onSelect: (e, value) => input.onSelect ? input.onSelect(e, value) : '',
    onSubmit: () => onSubmit(),
    options: input.options,
    optionSelect: input.optionSelect,
    pageType: pageType,
    placeholder: input.placeholder,
    readOnly: input.readOnly || false,
    searchType: input.searchType,
    section: (0, _get.default)(design, 'section', ''),
    showCountCharacters: (0, _get.default)(design, 'showCountCharacters', ''),
    selected: input.selected,
    setValue: val => setStateValue(val),
    showError: true,
    showSingleValCheck: (0, _get.default)(input, 'showSingleValCheck', ''),
    showPassword: (0, _get.default)(design, 'showPassword', ''),
    showStrongPassword: (0, _get.default)(design, 'showStrongPassword', ''),
    startFrom: input.startFrom,
    step: (0, _get.default)(inputFormat, 'step', undefined),
    tooltip: (0, _get.default)(input, 'tooltip', null),
    type: input.type,
    unit: input.unit,
    val: (0, _get.default)(formValue, input.name, ''),
    validation: ((0, _get.default)(input, 'validate', []) || []).length > 0
  })), (0, _get.default)(input, 'name', '').includes('autocomplete') && (0, _get.default)(autocomplete, `${nameAutocomplete}.data`, []).length > 0 && (/*#__PURE__*/_react.default.createElement("ul", {
    className: `autocompleteList ${(0, _get.default)(autocomplete, `${nameAutocomplete}.className`, '')}`
  }, (0, _get.default)(autocomplete, `${nameAutocomplete}.data`, []).map((item, i) => (/*#__PURE__*/_react.default.createElement("li", {
    key: `atc_${i.toString()}`,
    onClick: () => onClickAutocomplete(item.value),
    className: "mb-1"
  }, item.component ? (/*#__PURE__*/_react.default.createElement(item.component.name, item.component.props)) : (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-t"
  }, (0, _has.default)(item, 'avatar') && (/*#__PURE__*/_react.default.createElement(_BrixelAvatar.default, {
    className: "mr-2",
    profileId: item.value,
    name: item.title
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-perc-100"
  }, item.title && (/*#__PURE__*/_react.default.createElement("span", {
    className: "fweight-600 dis-b txtText900"
  }, item.title)), item.subtitle && (/*#__PURE__*/_react.default.createElement("span", {
    className: "txtLigh400 fSizePx14"
  }, item.subtitle)), item.value ? (/*#__PURE__*/_react.default.createElement("span", null, item.label)) : (/*#__PURE__*/_react.default.createElement("span", {
    className: "txtPrimary400"
  }, item.label)), (0, _has.default)(item, 'avatar') && (0, _has.default)(item, 'title') && (/*#__PURE__*/_react.default.createElement("hr", {
    className: "brdText200"
  })))))))))), (stateValue === 'other' || (0, _get.default)(formValue, `${input.name}`, null) === 'other' ||
  // @ts-ignore
  (0, _isArray.default)((0, _get.default)(formValue, `${input.name}`, [])) && (0, _get.default)(formValue, `${input.name}`, []).includes('other')) && allowOtherAnswerInput && (/*#__PURE__*/_react.default.createElement(_BrixelInputText.default, {
    className: "my-1",
    placeholder: (0, _get.default)(input, 'placeholderOther', null) || (0, _get.default)(labels, 'label', ''),
    input: {
      onChange: val => changeFieldValue(form, `${input.name}Other`, val),
      name: `${input.name}Other`,
      value: (0, _get.default)(formValue, `${input.name}Other`, '')
    }
  })), hintMessage && (/*#__PURE__*/_react.default.createElement("p", {
    className: "txtText600 pt-2 fsize-300 fsize-300"
  }, hintMessage))), showCheckMark && (/*#__PURE__*/_react.default.createElement("div", {
    className: "as-b checkIconWrap"
  }, isDone() === 'doneSection' || (0, _get.default)(formValue, input.name, null) === 0 ? (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    iconWidth: "w-fix-16",
    icon: "check-small-fill",
    color: "primary",
    saturationTxt: 700
  })) : (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    iconWidth: "w-fix-16",
    icon: "check-small",
    color: "text",
    saturationTxt: 100
  })))));
};
const mapStateToProps = (state, ownProps) => {
  const formValue = (0, _get.default)(state, `brixelForm[${ownProps.form}].values`, {});
  const initialValue = (0, _get.default)(state, `brixelForm[${ownProps.form}].initialValues`, {});
  return {
    currentInitialValue: (0, _get.default)(initialValue, ownProps.input.name, null),
    currentValue: (0, _get.default)(formValue, ownProps.input.name, null),
    errors: (0, _get.default)(state, `brixelForm[${ownProps.form}].syncErrors`, {}),
    form: ownProps.form,
    formValue,
    getAllFormData: (0, _get.default)(state, 'brixelForm', {}),
    initialValue,
    initialValues: formValue,
    lang: (0, _get.default)(state, 'common.language.code', (0, _get.default)(state, 'common.language', 'en')),
    registeredFields: (0, _get.default)(state, 'brixelForm.regFields', {})
  };
};
const mapDispatchToProps = dispatch => ({
  changeFieldValue(form, field, value) {
    dispatch((0, _ReduxForm.change)(form, field, value));
  },
  handleChangeSyncError(form, field, value) {
    dispatch((0, _ReduxForm.changeSyncError)(form, field, value));
  },
  handleUpdateValues: (0, _redux.bindActionCreators)(_FormActions.setValues, dispatch),
  handleSetRegisteredFields: (0, _redux.bindActionCreators)(_FormActions.setRegisteredFields, dispatch)
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReduxField);